import Layout from './Layout';
import withStyles from 'react-jss';
import styles from './styles';
var Styled = withStyles(styles)(Layout);
export default Styled;



//////////////////
// WEBPACK FOOTER
// ./src/containers/Layout/index.tsx
// module id = 539
// module chunks = 0